export default "__VITE_ASSET__DqaagBKg__"